import * as React from 'react';
import { connect } from 'react-redux';
import { setSelectedCover } from '../../actions/profileActions';
import { photoData } from '../../actions/cameraActions';
import { navigateTo } from '../../actions/navigationActions';

class ClaimCoverSelect extends React.Component<any, any> {

    render() {
        return (
            <>
                <div className="row d-lg-none d-xl-block d-md-block d-sm-block">
                    <div className="row">
                        <div className="col-lg-2 col-3 mt-3">
                            <div className={this.props.image + ' ml-md-2'}></div>
                        </div>
                        <div className="col-lg-10 col-9">
                            <div className="mt-3">
                                <p className="mb-0"><b>{this.props.headerText}</b></p>
                                <p className="notification descriptionText">{this.props.bodyText}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-lg-block d-xl-none d-md-none d-sm-none d-xs-none d-none">
                    <div className="row">
                        <div className="col-lg-10 col-9">
                            <div className="mt-3">
                                <p className="mb-0"><b>{this.props.headerText}</b></p>
                                <p className="notification descriptionText">{this.props.bodyText}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetSelectedCover: (id) => dispatch(setSelectedCover(id)),
        dispatchPhotoData: (data) => dispatch(photoData(data)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimCoverSelect);
